import { Link } from 'react-router-dom'
import { KeyRound } from 'lucide-react'

/** Rappel affiché tant qu'aucune entreprise de l'utilisateur n'a sa clé Pennylane. */
export default function PennylaneNotice({ children }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-amber-400/30 bg-amber-400/10 px-4 py-3 text-sm text-amber-100">
      <span>{children ?? 'Ajoutez la clé Pennylane de votre entreprise pour chiffrer avec l’agent, créer les devis et les factures.'}</span>
      <Link
        to="/dashboard/compte/entreprise"
        className="inline-flex items-center gap-2 rounded-xl border border-amber-300/40 px-3 py-1.5 font-semibold text-amber-200 hover:bg-amber-300/10"
      >
        <KeyRound className="h-4 w-4" />
        Compte > Entreprises
      </Link>
    </div>
  )
}
